import { useEffect, useState } from 'react';
export const useUIGameLandscapeResponsive = (containerRef)=>{
    const [containerFontSize, setContainerFontSize] = useState(1);
    useEffect(()=>{
        const baseFontSize = 16;
        const baseGameHeightPartition = 48;
        const baseHeight = baseFontSize * baseGameHeightPartition;
        const resizeObserver = new ResizeObserver(()=>{
            var _containerRef_current;
            var _containerRef_current_clientHeight;
            const containerHeight = (_containerRef_current_clientHeight = (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.clientHeight) !== null && _containerRef_current_clientHeight !== void 0 ? _containerRef_current_clientHeight : baseHeight;
            const newContainerFontSize = containerHeight / baseHeight;
            setContainerFontSize(newContainerFontSize);
        });
        if (containerRef.current) resizeObserver.observe(containerRef.current);
        return ()=>resizeObserver.disconnect();
    }, []);
    return containerFontSize;
};
